module.exports = "<div class=\"q-alert q-alert-grey\"> No documents have been attached yet. </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/html/fileNameRowMissing.html
// module id = 1379
// module chunks = 1